import ProductItem from "./ProductItem"

const ProductsItemList = ({ products, noProductsMessage}) => {
    return (
        <div>
            <div>
                {Boolean(products?.length) && products.map((product) => (
                    <ProductItem key={`product-item-${product.id}-in-branch-office-${product.branch_office_id}`} {...product}  />
                ))}
            </div>
            <div>
                {!Boolean(products?.length) && (
                    // <h4>La sucursal <strong>"{branchOffice.name}"</strong> no tiene productos.</h4>
                    <h4>{noProductsMessage}</h4>
                )}
            </div>
        </div>
    )
}

export default ProductsItemList